module.exports = __webpack_public_path__ + "fonts/iconfont.f6c0b652.ttf";